// @flow
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useFormikContext } from 'formik';
import { SPUserCommitDetailsContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitDetailsContext';
import {
  useCreateCommittedCapacityMetricLineItemMutation,
  useUpdateCommittedCapacityMetricLineItemMutation,
} from '@streaming-projects/service-definitions/streamingProjectsApi';
import {
  getIfAnyOtherRowBesidesTheGivenRowIsBeingEdited,
  getIfGivenRowIsANewlyAddedRow,
  getIfGivenRowIsBeingEditedORANewOne,
  getMetricDimensionsFromMetricName,
} from '@streaming-projects/user-commit-details/committed-capacity/utils';
import { pickKeysFromObject } from '@src/common-utils/utils';
import { toastError } from '@presentational/notifications/utils';
import { IS_ROW_OPENED_FOR_EDITING, ROW_ID } from '@src/constants';
import { SaveFormButton } from '@presentational/buttons/SaveFormButton';
import { COMMITTED_CAPACITY } from '@streaming-projects/user-commit-details/committed-capacity/enums';

export const CommittedCapacityDimensionsLineItemSaveContainer = ({
  dimensionRow,
  metricRow,
  configuredMetrics,
  dimensionIndex,
  dimensionArrayHelpers,
  reloadPageAfterUpdate,
}) => {
  const { orgId, commitId } = useParams();
  const { isValid } = useFormikContext();
  const commitData = useContext(SPUserCommitDetailsContext);

  const [updateFunc] = useUpdateCommittedCapacityMetricLineItemMutation();
  const [createFunc] = useCreateCommittedCapacityMetricLineItemMutation();

  const isAnyOtherRowBesidesTheGivenRowBeingEdited =
    getIfAnyOtherRowBesidesTheGivenRowIsBeingEdited(configuredMetrics, dimensionRow);

  /*
     Update button should be disabled if the form is not valid
     It should also be disabled if any other row besides this row is being edited
     Finally, If this row is being edited, then it should be enabled
     */
  const shouldUpdateButtonBeDisabled =
    !getIfGivenRowIsBeingEditedORANewOne(dimensionRow) ||
    !isValid ||
    isAnyOtherRowBesidesTheGivenRowBeingEdited;

  const handleSave = async () => {
    const funcToUse = getIfGivenRowIsANewlyAddedRow(dimensionRow) ? createFunc : updateFunc;
    const payload = {
      ...dimensionRow,
      metric_type: metricRow.metricName,
      resource_configuration_type: {
        ...pickKeysFromObject(
          dimensionRow,
          getMetricDimensionsFromMetricName(metricRow.metricName)
        ),
      },
      commit_version: commitData?.version,
    };

    const params = {
      orgId,
      commitId,
      committedCapacityId: dimensionRow[COMMITTED_CAPACITY.ID_BACKEND_FIELD_NAME],
      payload,
    };

    const { data, error } = await funcToUse(params);

    if (error) {
      toastError(error);
    } else {
      if (reloadPageAfterUpdate) {
        window.location.reload();
      }
      dimensionArrayHelpers.replace(dimensionIndex, {
        ...dimensionRow,
        [IS_ROW_OPENED_FOR_EDITING]: false,
        [ROW_ID]: data[COMMITTED_CAPACITY.ID_BACKEND_FIELD_NAME],
      });
    }
  };

  return <SaveFormButton disabled={shouldUpdateButtonBeDisabled} onClick={handleSave} />;
};
